import { Injectable, Output, EventEmitter } from '@angular/core';


@Injectable()
export class NotifyToStoryService {
    @Output() getDirtyStoryId: EventEmitter<number> = new EventEmitter();
    @Output() getStoryDirtyStatus: EventEmitter<boolean> = new EventEmitter();

    public emitDirtyStoryStatus (status: boolean): void {
        this.getStoryDirtyStatus.emit(status);
    }

    public emitDirtyStoryId (id: number): void {
        this.getDirtyStoryId.emit(id);
    }
}
